import { render } from "./BaseContactUs.vue?vue&type=template&id=216df270&scoped=true"
import script from "./BaseContactUs.vue?vue&type=script&lang=js"
export * from "./BaseContactUs.vue?vue&type=script&lang=js"

import "./BaseContactUs.vue?vue&type=style&index=0&id=216df270&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216df270"]])

export default __exports__